import { localize2WithPath } from '../../../nls.js';
const _moduleId = "vs/platform/action/common/actionCommonCategories";
const Categories = ( (Object.freeze({
    View: ( localize2WithPath(_moduleId, 0, 'View')),
    Help: ( localize2WithPath(_moduleId, 1, 'Help')),
    Test: ( localize2WithPath(_moduleId, 2, 'Test')),
    File: ( localize2WithPath(_moduleId, 3, 'File')),
    Preferences: ( localize2WithPath(_moduleId, 4, 'Preferences')),
    Developer: ( localize2WithPath(_moduleId, 5, "Developer")),
})));
export { Categories };
